import { Component, OnInit, Input, ViewEncapsulation, ElementRef } from '@angular/core';
import { ObservablesService } from 'src/app/Services/observables/observables';
import { StoreService } from 'src/app/Services/store';

@Component({
	selector: 'CustomHtml',
	template: ` <span
		gtm-handler
		[attr.gtm]="control.attributes.gaEventLabel"
		events="click"
		handlerType="button"
		[label]="control.attributes.gaEventLabel"
		action="LinkClick"
		[innerHTML]="control.attributes.content || content | noSanitize"
		[ngClass]="control.attributes && control.attributes.class"
	>
	</span>`,
	styleUrls: ['./custom-html.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CustomHtmlCompnent implements OnInit {
	@Input() content: any;
	@Input() control: control;
	@Input() gtmEventData: any;

	constructor(
		private storeService: StoreService,
		private elementRef: ElementRef,
		private observablesService: ObservablesService
	) {}

	async ngOnInit() {
		if (this.control.disabled) {
			setTimeout(() => {
				const elements = this.elementRef.nativeElement.querySelectorAll('a');
				for (let el of elements) {
					if (el) {
						el.classList.add('disabled');
						el.removeAttribute('href');
						el.removeAttribute('target');
					}
				}
			}, 0);
		}
		if (this.control.name === 'CustomHtml.Disclaimer') {
			this.observablesService.pageUpdated.subscribe((action) => {
				if (this.control && this.control.name)
					this.control = this.storeService.getControl(this.control.name, this.control.controlType, 'page');
			});
		}
	}
}
